import { lazy } from 'react';

import type { RoutesConfig, WrapRoutes } from '@virtuslab/nfs-shared/src/services/routes';

import { ProgressionRoutes } from '../../../config/paths';

const ProgressionPage = lazy(async () => import('.'));

const config: RoutesConfig<WrapRoutes<typeof ProgressionRoutes>> = {
  paths: {
    [ProgressionRoutes.PROGRESSION]: {
      render: ProgressionPage,
    },
  },
};

export default config;
